











































































































































































































































































































































































































































































































































































































































import { Component, Vue, Mixins, Watch, Model } from "vue-property-decorator";
import clipboard from "clipboard";
import loading from "@/mixins/loading";
import debounce from "@/utils/debounce";
import toFixed from "@/utils/decimal";

// 接口
import {
  orderList,
  orderUpdateRemark,
  orderUpdateStatus,
  orderSendExpress,
  selectExpress,
  selectOrderByMainId,
  selectExpressByOrderId,
  initiativeReturn,
} from "@/api/order";
import { expressCompanyList } from "@/api/freight";

@Component({
  components: {},
})
export default class OrderDetail extends Mixins(loading) {
  orderDetail: any = {};
  allProductAmount: any = 0;
  preAmount: any = 0;
  allRecommendedCost: any = 0;
  dialogVisibleRemark: boolean = false;
  dialogVisibleReturn: boolean = false;
  dialogReturnOrder: any = [];
  form: any = {
    remark: "",
    id: 0,
  };
  activities: any = [];

  returnAmount: any = 0;

  rules = [
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value > 0) {
          callback();
        } else {
          return callback(new Error("退款金额必须大于0"));
        }
      },
      trigger: "blur",
    },
  ];

  mounted() {
    let route: any = this.$route;
    let { orderId } = route.query;
    if (!orderId) {
      this.$message.error("订单号不能为空");
      return;
    }
    this.showLoading();
    this.getData(orderId);
  }

  getData(orderId: number) {
    this.allProductAmount = 0;
    this.preAmount = 0;
    this.allRecommendedCost = 0;
    selectOrderByMainId({
      id: orderId,
    }).then((res: any) => {
      this.hideLoading();
      this.orderDetail = res.data;
      res.data.omsOrderItems.forEach((e: any) => {
        this.allProductAmount += e.memberPrice * e.productQuantity;
        this.preAmount += (e.price - e.memberPrice) * e.productQuantity;
        this.allRecommendedCost += e.recommendedCost;
      });
      this.allProductAmount = this.fixedPrice(this.allProductAmount);
      this.preAmount = this.fixedPrice(this.preAmount);
      this.allRecommendedCost = this.fixedPrice(this.allRecommendedCost);
      selectExpressByOrderId({ orderId: orderId }).then((res: any) => {
        try {
          this.activities = (res.data && res.data.tracesObj) || [];
        } catch (error) {}
      });
    });
  }

  fixedPrice(price: string | number) {
    return toFixed(price);
  }
  changeReturnAmount(val: any, omsOrderItem: any) {
    omsOrderItem.returnAmount = val;
    this.dialogReturnOrder = [omsOrderItem];
    this.returnAmount = val;
  }

  traces(orderExpress: any) {
    let state = orderExpress && orderExpress.state;
    let traceStr = "";
    if (state == 0) {
      traceStr = "包裹导入";
    }
    if (state == 2) {
      traceStr = "在途中";
    }
    if (state == 3) {
      traceStr = "签收";
    }
    if (state == 4) {
      traceStr = "问题件";
    }

    return traceStr;
  }

  getActive() {
    let active = 1;
    let { status } = this.orderDetail;
    switch (status) {
      case 0:
        active = 1;
        break;
      case 3:
        active = 3;
        break;
      case 5:
        active = 4;
        break;
      case 9:
        active = 5;
        break;
    }
    return active;
  }

  viewReturn(omsOrderItem: any) {
    this.dialogVisibleReturn = true;
    this.dialogReturnOrder = [omsOrderItem];
  }

  viewReturnDetail(omsOrderItem: any) {
    let orderId = omsOrderItem.id;
    this.$router.push({
      path: "/returnDetail",
      query: { orderId: orderId },
    });
  }

  // 表头样式
  headerCellStyle() {
    return {
      background: "#eef1f6",
      color: "#606266",
      textAlign: "center",
    };
  }

  tableRowClassName() {
    return "order-table";
  }

  // 修改备注
  updateRemark() {
    this.dialogVisibleRemark = true;
  }

  // 确认修改修改订单
  async confirmUpdate() {
    this.form.id = this.orderDetail.id;
    let form = this.form;
    await orderUpdateRemark(form);
    this.dialogVisibleRemark = false;
    this.showLoading();
    this.getData(this.orderDetail.id);
  }

  cancelUpdate() {
    this.dialogVisibleRemark = false;
    this.form = {
      remark: "",
      id: this.orderDetail.id,
    };
  }

  viewAfterDetail(omsOrderItem: any) {
    let orderId = omsOrderItem.id;
    this.$router.push({
      path: "/afterDetail",
      query: { orderId: orderId },
    });
  }

  async confirmReturn() {
    let omsOrderItem = this.dialogReturnOrder[0];
    let subOrderId = omsOrderItem.id;
    let returnAmount = omsOrderItem.returnAmount;
    let ruleForm: any = this.$refs["ruleForm"];

    ruleForm.validate((valid: any) => {
      if (valid) {
        initiativeReturn({ subOrderId, returnAmount })
          .then(() => {
            this.dialogVisibleReturn = false;
            this.showLoading();
            this.getData(this.orderDetail.id);
          })
          .catch(() => {
            this.dialogVisibleReturn = false;
          });
      } else {
        return false;
      }
    });
  }

  copy() {
    let me = this;
    // TODO: 复制格式待定
    let clipboardInfo = new clipboard(".cobyAddInfo", {
      text: function () {
        let str = "";
        let { orderAddress } = me.orderDetail;
        str = orderAddress.receiverName;
        str += ";" + orderAddress.receiverPhone;
        str +=
          ";" +
          orderAddress.receiverProvince +
          orderAddress.receiverCity +
          orderAddress.receiverRegion +
          orderAddress.receiverDetailAddress;
        return str;
      },
    });
    clipboardInfo.on("success", () => {
      this.$message.success("复制成功");
      clipboardInfo.destroy();
    });
    clipboardInfo.on("error", () => {
      this.$message.error("复制失败，请手动复制");
    });
  }
}
